import * as React from 'react';

const SettingsContext = React.createContext();

const useSettingsContext = () => React.useContext(SettingsContext);

export { SettingsContext, useSettingsContext };
